<template>
  <div class="shoot-analysis">
    <div class="shoot-analysis-left">
      <el-table :data="tableData" height="100%">
        <el-table-column>
          <template slot-scope="scope">
            {{ scope.row.playerAbbr }}（#{{ scope.row.shirtNumber }}）
          </template>
        </el-table-column>
        <!-- 关键传球 -->
        <template v-if="dataType === 'keyPass'">
          <el-table-column label="总计" :align="'center'" width="70">
            <template slot-scope="scope">
              {{ scope.row.keypassesAssists }}
            </template>
          </el-table-column>
        </template>
        <!-- 射门分析 -->
        <template v-else>
          <el-table-column
            label="禁区内"
            prop="shotsInsideBox"
            width="70"
            :align="'center'"
          />
          <el-table-column
            label="禁区外"
            prop="shotsOutsideBox"
            width="70"
            :align="'center'"
          />
        </template>
      </el-table>
    </div>
    <div class="shoot-analysis-right">
      <div class="country-info">
        <div class="country-logo">
          <img :src="objectInfo.teamLogo" alt="" />
        </div>
        <div class="country-name">
          {{ objectInfo.teamName }}
        </div>
      </div>
      <ShootMap
        :is-auto-export-png="isAutoExportPng"
        :data="dataList"
        :data-type="dataType"
        @uploadData="handleUploadData"
      />
    </div>
  </div>
</template>

<script>
import ShootMap from './ShootMap.vue'
export default {
  name: 'shoot_analysis',
  components: {
    ShootMap,
  },
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
          legendData: [],
        },
      }),
    },
    isAutoExportPng: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    objectInfo() {
      return this.datas?.objectInfo?.[0] || {}
    },
    playerInfo() {
      return this.objectInfo?.playerInfos?.[0] || {}
    },
    isAway() {
      const teamType = this.objectInfo?.teamType
      return teamType === 'away'
    },
    tableData() {
      return this.datas?.data?.legendData?.[0]?.rank || []
    },
    dataList() {
      return this.datas?.data?.dataList || []
    },
    dataType() {
      return this.datas?.data?.dataType || 'keyPass' // shot射门 keyPass关键传球
    },
  },
  methods: {
    handleUploadData(imgdata) {
      this.$emit('uploadData', { imgdata })
    },
  },
}
</script>

<style lang="scss" scoped>
.shoot-analysis {
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  gap: 1%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .shoot-analysis-left {
    flex-shrink: 0;
    width: 40%;
    height: 100%;
    padding: 2px 0;
    display: flex;
    overflow-y: auto;
    padding-top: 3.5vw;
    :deep(.el-table) {
      height: 100%;
      &::before {
        display: none;
      }
      .el-table__cell {
        padding-top: 0.6vw;
        padding-bottom: 0.6vw;
      }
      .el-table__body-wrapper {
        .el-table__row:nth-child(2n - 1) {
          .el-table__cell {
            background-color: var(--mixtmt_table_headerBg) !important;
          }
        }
      }
      .cell {
        padding: 0 0.5vw;
        // white-space: nowrap;
      }
    }
  }
  .shoot-analysis-right {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .country-info {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .country-logo {
        width: 3.5vw;
        height: 3.5vw;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .country-name {
        margin-left: 0.5vw;
        font-size: 1.2vw;
        color: var(--mixtmt_greyColor_main);
      }
    }
  }
}
</style>
